import { render, staticRenderFns } from "./ReportUpload.vue?vue&type=template&id=028ff31a&scoped=true&"
import script from "./ReportUpload.vue?vue&type=script&lang=js&"
export * from "./ReportUpload.vue?vue&type=script&lang=js&"
import style0 from "./ReportUpload.vue?vue&type=style&index=0&id=028ff31a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "028ff31a",
  null
  
)

export default component.exports